<div class="topbar">

  <ul class="topbar-styles">

    <li *ngIf="user.authenticated&&user.hasFullAccessToMenu" class="wide-nav traynav-trigger">
      <a #topBarMenuButton id="menu-button" [routerLink]="" (click)="app.onMenuButtonClick($event)"><i class="fa fa-navicon"></i>
        <div class="nav-orgname">{{user?.info?.orgName}}</div>
      </a>
    </li>
    <li *ngIf="user.authenticated&&user.hasFullAccessToMenu" class="small-nav">
      <a [routerLink]="RouteLink.Home" routerLinkActive="active" pTooltip="Home" tooltipPosition="bottom">
        <i class="fa fa-home"></i>
      </a>
    </li>
    <li *ngIf="user.authenticated&&!user.hasFullAccessToMenu&&user.hasRole[Roles.Customer]" class="small-nav">
      <a [routerLink]="RouteLink.CustomerHome" routerLinkActive="active" pTooltip="Home" tooltipPosition="bottom">
        <i class="fa fa-home"></i>
      </a>
    </li>
    <li *ngIf="user.authenticated&&user.hasFullAccessToMenu" class="small-nav">
      <a [routerLink]="RouteLink.Services" routerLinkActive="active" pTooltip="Services" tooltipPosition="bottom">
        <i class="fa fa-cubes"></i>
      </a>
    </li>
    <li *ngIf="user.authenticated&&user.hasFullAccessToMenu" class="small-nav betafeedback-wrapper">
      <a (click)="onClickEnableFeedback( $event, op)" pTooltip="Feedback" tooltipPosition="bottom" style="text-decoration:none;cursor:pointer;">
        <i class="fa fa-comments"></i>
      </a>
      <p-overlayPanel [style]="{'width':'400px'}" #op #betaFeedback>
        <div *ngIf="enableFeedback" class="dropdown-betafeedback">
          <app-suggestion-management></app-suggestion-management>
        </div>
      </p-overlayPanel>
    </li>

    <li *ngIf="user.authenticated&&user.hasFullAccessToMenu" class="small-nav">
      <a [routerLink]="RouteLink.Worklist" routerLinkActive="active" pTooltip="Worklist" tooltipPosition="bottom" style="text-decoration:none;">
        <i class="fa fa-th-list"></i>
        <div class="worklist-badge">{{user.worklistSubmittedOrApproved}}</div>
      </a>
    </li>

    <li *ngIf="user.instance!==EnvironmentType.Sandbox" class="wide-nav topbar-logo">
      <a *ngIf="user.hasFullAccessToMenu" [routerLink]="RouteLink.Home">
        <img [attr.src]="app.layout === 'default' ? 'assets/img/logo-black-sm.png' : 'assets/img/logo-black-sm.png'">
      </a>
      <a *ngIf="!user.hasFullAccessToMenu&&user?.info?.subtype===UserType.Candidate" [routerLink]="RouteLink.CandidateHome">
        <img [attr.src]="app.layout === 'default' ? 'assets/img/logo-black-sm.png' : 'assets/img/logo-black-sm.png'">
      </a>
      <a *ngIf="!user.hasFullAccessToMenu&&user?.info?.subtype===UserType.Customer" [routerLink]="RouteLink.CustomerHome">
        <img [attr.src]="app.layout === 'default' ? 'assets/img/logo-black-sm.png' : 'assets/img/logo-black-sm.png'">
      </a>
      <a *ngIf="!user.hasFullAccessToMenu&&!user?.info">
        <img [attr.src]="app.layout === 'default' ? 'assets/img/logo-black-sm.png' : 'assets/img/logo-black-sm.png'">
      </a>
    </li>

    <li *ngIf="user.instance===EnvironmentType.Sandbox" class="wide-nav topbar-logo">
      <a *ngIf="user.hasFullAccessToMenu" [routerLink]="RouteLink.Home">
        <img [attr.src]="app.layout === 'default' ? 'assets/img/logo-sandbox.png' : 'assets/img/logo-sandbox.png'">
      </a>
      <a *ngIf="!user.hasFullAccessToMenu&&user?.info?.subtype===UserType.Candidate" [routerLink]="RouteLink.CandidateHome">
        <img [attr.src]="app.layout === 'default' ? 'assets/img/logo-sandbox.png' : 'assets/img/logo-sandbox.png'">
      </a>
      <a *ngIf="!user.hasFullAccessToMenu&&user?.info?.subtype===UserType.Customer" [routerLink]="RouteLink.CustomerHome">
        <img [attr.src]="app.layout === 'default' ? 'assets/img/logo-sandbox.png' : 'assets/img/logo-sandbox.png'">
      </a>
      <a *ngIf="!user.hasFullAccessToMenu&&!user?.info">
        <img [attr.src]="app.layout === 'default' ? 'assets/img/logo-sandbox.png' : 'assets/img/logo-sandbox.png'">
      </a>
    </li>

    <li *ngIf="user.authenticated&&user.hasFullAccessToMenu" class="small-nav">
      <a [routerLink]="RouteLink.Delegation" routerLinkActive="active" pTooltip="Delegation" tooltipPosition="bottom">
        <i class="fa fa-id-badge"></i>
      </a>
    </li>

    <li *ngIf="user.authenticated&&user.hasFullAccessToMenu" class="small-nav">
      <a [routerLink]="RouteLink.CorpCalendar" routerLinkActive="active" pTooltip="Calendar" tooltipPosition="bottom">
        <i class="fa fa-calendar"></i>
      </a>
    </li>

    <li *ngIf="user.authenticated&&(user.hasFullAccessToMenu||!user.hasFullAccessToMenu&&user?.info?.subtype===UserType.Customer)" class="small-nav">
      <a [routerLink]="RouteLink.Help" routerLinkActive="active" pTooltip="Help" tooltipPosition="bottom">
        <i class="fa fa-info"></i>
      </a>
    </li>

    <li *ngIf="user.authenticated" class="small-nav">
      <a (click)="initiateConnect()" pTooltip="Connect Chat" tooltipPosition="bottom" style="cursor:pointer;text-decoration:none;">
        <i class="fa fa-users"></i>
        <div *ngIf="app.connectNotification" class="connectmessage-badge"></div>
      </a>
    </li>

    <!--    FixMe - uncomment before going live-->
    <!--    <li class="small-nav devtools-wrapper" *ngIf="user.authenticated&&user.hasFullAccessToMenu&&user.instance!=EnvironmentType.Production">-->
    <li *ngIf="user.authenticated&&user.instance!==EnvironmentType.Production" class="small-nav devtools-wrapper">
      <a pTooltip="Dev Tools" tooltipPosition="bottom" (click)="devtools.toggle($event)">
        <i class="fa fa-gear devtools"></i>
      </a>

      <p-overlayPanel #devtools>
        <div class="dropdown-devtools">
          <h4>This icon &amp; menu will only appear with the proper role.</h4>
          <ul class="fadeInDown" id="devtools-menu">
            <li>
              <a routerLink="/keycloak-info" routerLinkActive="active">Keycloak Info</a>
            </li>
            <li>
              <a routerLink="/check-auth" routerLinkActive="active">Check Auth</a>
            </li>
            <li>
              <p-button (onClick)="onClickPrintCache()" label="Print Cache"></p-button>
            </li>
            <li>
              <a [routerLink]="RouteLink.TestFileExplorer" routerLinkActive="active">Test File Explorer</a>
            </li>
            <li>
              <a routerLink="test/test-add-line-item" routerLinkActive="active">Test Add Line Item</a>
            </li>
            <li>
              <a routerLink="hcm/recruit-to-hire/exit-interview" routerLinkActive="active">Exit Survey</a>
            </li>
            <li>
              <a routerLink="common/org-termination" routerLinkActive="active"> Termination</a>
            </li>
            <li>
              <a [routerLink]="RouteLink.PurchaseReturn" routerLinkActive="active">Item Return</a>
            </li>
          </ul>
        </div>
      </p-overlayPanel>
    </li>

    <div class="topbar-right">
      <a *ngIf="user.authenticated && user.dataserviceAvailable"
         href="#" id="user-display" pTooltip="My Profile" tooltipPosition="bottom"
         (click)="app.onTopbarMenuButtonClick($event)">
        <span class="username">
          <div>{{user?.info?.fullName}}</div>
          <img alt="View Profile" id="myPicture" src="" style="border: 0px;">
          <i class="fa fa-angle-down"></i>
        </span>
      </a>
      <div class="dropdown-profile">
        <ul id="topbar-menu" class="fadeInDown" [ngClass]="{'topbar-menu-visible': app.topbarMenuActive}">
          <li #profile *ngIf="user.hasFullAccessToMenu" [ngClass]="{'menuitem-active':app.activeTopbarItem === profile}">
            <a href="#" [routerLink]="RouteLink.Profile" routerLinkActive="active" style="text-decoration:none;"
               (click)="app.onTopbarItemClick($event, profile)">
              <i class="topbar-icon fa fa-fw fa-user"></i>
              <span class="topbar-item-name">Profile</span>
            </a>
          </li>
          <li #logout [ngClass]="{'menuitem-active':app.activeTopbarItem === logout}">
            <a (click)="app.onClickLogout()" style="cursor:pointer;text-decoration:none;">
              <i class="fa fa-fw fa-sign-out"></i>
              <span class="topbar-item-name">Logout</span>
            </a>
          </li>
        </ul>
      </div>
    </div>

  </ul>


  <app-growl></app-growl>
</div>
